class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

// class CartBundleAdd extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener("click", (event) => {
//       event.preventDefault();
//       event.stopPropagation();

//       const lineItemElement = this.closest('[data-line-key]');
//       if (!lineItemElement) return;

//       const currentQuantityInput = lineItemElement.querySelector('input[name="updates[]"]');
//       if (!currentQuantityInput) return;

//       const currentQuantity = parseInt(currentQuantityInput?.value);

//       const newQuantity = currentQuantity + 1;
//       console.log({newQuantity})

//       const cartItems =
//         this.closest("cart-items") || this.closest("cart-drawer-items");

//       cartItems.updateQuantity(this.dataset.index, newQuantity, event);
//     });
//   }
// }
// customElements.define("cart-bundle-add", CartBundleAdd);

class CartBundleRemove extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0, event);
    });
  }
}
customElements.define("cart-bundle-remove", CartBundleRemove);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  getCanonicalComponentJson(components) {
    const sortedComponents = [...components].sort((a, b) => {
      const idA = a.id.includes("gid://") ? a.id.split("/").pop() : a.id;
      const idB = b.id.includes("gid://") ? b.id.split("/").pop() : b.id;
      return idA.localeCompare(idB);
    });

    return JSON.stringify(sortedComponents);
  }

  async addBundleToCart(lineItemElement, line, variantId) {
    this.enableLoading(line);

    const componentListString = lineItemElement?.dataset?.items;
    // const bundleVariantId = lineItemElement?.dataset?.bundleVariantId;
    const bundleVariantId = `gid://shopify/ProductVariant/${variantId}`;
    const bundleSize = lineItemElement.dataset.bundleSize;

    if (!bundleVariantId) {
      console.error("Bundle data (componentsJson) not found on element.");
      this.disableLoading(line);
      return;
    }

    const arrayComponent = componentListString.split(',');
    const components = arrayComponent.map(item => {
      const arrayItem = item.split(' - ');
      /**Parse from string title with quanity, etc: Angrula x 2 */
      const quantity = arrayItem[0].split(' x ')[1];
      
      return {
        id: arrayItem[1],
        quantity: quantity
      }
    });

    try {
      // const currentGroupId = lineItemElement.dataset.bundleGroupId;
      // const newGroupId = currentGroupId || Date.now().toString();
      const newGroupId = Date.now().toString();

      const items = components.map((item) => ({
        id: item.id,
        quantity: item.quantity,
        properties: {
          _items: componentListString,
          _bundleVariantId: bundleVariantId,
          _bundle_group_id: newGroupId,
          _bundle_size: bundleSize,
          // _components_json: componentsJsonString,
        },
      }));
      const sectionsToRender = ["cart-drawer", "cart-icon-bubble", "main-cart-items"];

      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });


      if (response.ok) {
        const responseText = await response.text();
        
        let sectionsData;

        try {
          sectionsData = JSON.parse(responseText);
        } catch (error) {
          console.error(
            "Liquid Rendering Crash: Server returned HTML error instead of JSON for /cart/add.js. Root cause: Liquid Crash.",
            responseText
          );
          this.disableLoading(line);
          alertModal(
            "Added successfully, but cart failed to update. Please check Liquid files or refresh."
          );
          return;
        }

        const sections = sectionsData.sections;

        const newBubbleHtml = sections["cart-icon-bubble"];
        const currentAnchor = document.getElementById("cart-icon-bubble");

        if (currentAnchor && newBubbleHtml) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = newBubbleHtml;
          const targetContent = tempDiv.querySelector(".cart-count-bubble")
            ? tempDiv.innerHTML
            : "";
          currentAnchor.innerHTML = targetContent;

          const newBubble = currentAnchor.querySelector(".cart-count-bubble");
          if (newBubble) {
            newBubble.style.display = "block";
            newBubble.classList.add("animate-pop");
            setTimeout(() => newBubble.classList.remove("animate-pop"), 500);
          }
        } else {
          console.error(
            "Error: Could not find current cart anchor or failed to fetch cart sections."
          );
        }

        const cartDrawerComponent = document.querySelector("cart-drawer");
        const newCartHtml = sections["cart-drawer"];

        if (cartDrawerComponent && newCartHtml) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = newCartHtml;

          const newCartDrawerInnerContent =
            tempDiv.querySelector("#CartDrawer");

          const currentCartDrawerInner = document.getElementById("CartDrawer");

          if (currentCartDrawerInner && newCartDrawerInnerContent) {
            currentCartDrawerInner.innerHTML =
              newCartDrawerInnerContent.innerHTML;
          } else {
            const newCartDrawerComponent = tempDiv.querySelector("cart-drawer");
            if (newCartDrawerComponent) {
              const parent = cartDrawerComponent.parentNode;
              parent.replaceChild(newCartDrawerComponent, cartDrawerComponent);
            }
          }
        }

        this.disableLoading(line);

        window.dispatchEvent(
          new CustomEvent("cart:add", {
            bubbles: true,
            detail: { sections: sections },
          })
        );
      } else {
        const error = await response.json();
        this.disableLoading(line);
        alertModal(
          "Error adding bundle to cart: " + (error.description || error.message)
        );
      }
    } catch (error) {
      console.error("Add Bundle Process Failed:", error);
      this.disableLoading(line);
      alertModal(
        "A network error occurred or cart update failed. Please try again."
      );
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        return this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      return fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".cart-footer-contents",
      },
    ];
  }

  updateQuantity(line, quantity, event, name, variantId) {
    const lineItemElement =
      document.getElementById(`CartDrawer-Item-${line}`) ||
      document.getElementById(`CartItem-${line}`);

    const isBundle =
      lineItemElement && lineItemElement.dataset.bundleGroupId;

    if (isBundle) {
      const currentQuantity = parseInt(
        lineItemElement.querySelector(".quantity__input").dataset.cartQuantity
      );
      const newQuantity = quantity;

      if (newQuantity > currentQuantity && name === "plus") {
        if (event.target) {
          event.target.value = currentQuantity;
        }

        this.addBundleToCart(lineItemElement, line, variantId);
        return;
      }
      // } else if (newQuantity < currentQuantity && newQuantity > 0) {
      //   const cartItems =
      //     this.closest("cart-items") || this.closest("cart-drawer-items");
      //   cartItems.updateQuantity(this.dataset.index, 2, event);

      //   if (event.target) {
      //     event.target.value = currentQuantity;
      //   }
      //   this.removeBundleFromCart(lineItemElement, line);
      //   return;
      // } else if (newQuantity === 0) {
      //           const cartItems =
      //     this.closest("cart-items") || this.closest("cart-drawer-items");
      //   cartItems.updateQuantity(this.dataset.index, 0, event);
      // }
    }

    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        this.handleUpdateResponse(state, line, event, name, variantId);
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  async removeBundleFromCart(lineItemElement, line) {
    this.enableLoading(line);

    const lineIndexOrKey = line;
    let currentQuantity = 1;

    const quantityInput = lineItemElement.querySelector(
      'input[name="updates[]"]'
    );

    if (quantityInput && quantityInput.value) {
      currentQuantity = parseInt(quantityInput.value);
    } else {
      currentQuantity = parseInt(lineItemElement.dataset.quantity || 1);
    }

    console.log(`[DEBUG] Current Qty found (Before Minus): ${currentQuantity}`);

    if (isNaN(currentQuantity) || currentQuantity <= 0) {
      console.error("Current quantity is invalid or zero. Cannot decrement.");
      this.disableLoading(line);
      return;
    }

    const newQuantity = Math.max(0, currentQuantity - 1);

    console.log(`[DEBUG] Calculated New Qty (Sent to Shopify): ${newQuantity}`);

    const sectionsToRender = ["cart-drawer", "cart-icon-bubble"];

    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          line: lineIndexOrKey,
          quantity: newQuantity,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      if (response.ok) {
        const responseText = await response.text();

        let sectionsData;

        try {
          sectionsData = JSON.parse(responseText);
        } catch (error) {
          console.error(
            "Liquid Rendering Crash: Server returned HTML error instead of JSON for /cart/change.js.",
            responseText
          );
          this.disableLoading(line);
          window.alert(
            "Update successful, but cart failed to render. Please check Liquid files or refresh."
          );
          return;
        }

        const sections = sectionsData.sections;
        const newBubbleHtml = sections["cart-icon-bubble"];
        const currentAnchor = document.getElementById("cart-icon-bubble");
        if (currentAnchor && newBubbleHtml) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = newBubbleHtml;
          const targetContent = tempDiv.querySelector(".cart-count-bubble")
            ? tempDiv.innerHTML
            : "";
          currentAnchor.innerHTML = targetContent;

          const newBubble = currentAnchor.querySelector(".cart-count-bubble");
          if (newBubble) {
            newBubble.style.display = "block";
          }
        }

        const cartDrawerComponent = document.querySelector("cart-drawer");
        const newCartHtml = sections["cart-drawer"];
        if (cartDrawerComponent && newCartHtml) {
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = newCartHtml;
          const newCartDrawerInnerContent =
            tempDiv.querySelector("#CartDrawer");
          const currentCartDrawerInner = document.getElementById("CartDrawer");
          if (currentCartDrawerInner && newCartDrawerInnerContent) {
            currentCartDrawerInner.innerHTML =
              newCartDrawerInnerContent.innerHTML;
          } else {
            const newCartDrawerComponent = tempDiv.querySelector("cart-drawer");
            if (newCartDrawerComponent) {
              const parent = cartDrawerComponent.parentNode;
              parent.replaceChild(newCartDrawerComponent, cartDrawerComponent);
            }
          }
        }

        this.disableLoading(line);

        window.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
            detail: { sections: sections },
          })
        );
      } else {
        const error = await response.json();
        this.disableLoading(line);
        window.alert(
          "Error changing bundle quantity: " +
            (error.description || error.message)
        );
      }
    } catch (error) {
      console.error("Remove Bundle Process Failed:", error);
      this.disableLoading(line);
      window.alert(
        "A network error occurred or cart update failed. Please try again."
      );
    }
  }
  handleUpdateResponse(state, line, event, name, variantId) {
    const parsedState = JSON.parse(state);

    CartPerformance.measure(`updateQuantity:paint-updated-sections"`, () => {
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      const items = document.querySelectorAll(".cart-item");

      if (parsedState.errors) {
        if (quantityElement)
          quantityElement.value = quantityElement.getAttribute("value");
        this.updateLiveRegions(line, parsedState.errors);
        return;
      }

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector("cart-drawer");
      const cartFooter = document.getElementById("main-cart-footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );

      this.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        if (parsedState.sections && parsedState.sections[section.section]) {
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        }
      });

      const updatedValue = parsedState.items.find(
        (item) => item.id.toString() === variantId
      )?.quantity;

      let message = "";
      if (
        items.length === parsedState.items.length &&
        updatedValue !== parseInt(quantityElement.value)
      ) {
        if (typeof updatedValue === "undefined") {
          message = window.cartStrings.error;
        } else {
          message = window.cartStrings.quantityError.replace(
            "[quantity]",
            updatedValue
          );
        }
      }
      this.updateLiveRegions(line, message);

      const lineItem =
        document.getElementById(`CartItem-${line}`) ||
        document.getElementById(`CartDrawer-Item-${line}`);
      if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
        cartDrawerWrapper
          ? trapFocus(
              cartDrawerWrapper,
              lineItem.querySelector(`[name="${name}"]`)
            )
          : lineItem.querySelector(`[name="${name}"]`).focus();
      } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper.querySelector(".drawer__inner-empty"),
          cartDrawerWrapper.querySelector("a")
        );
      } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
        trapFocus(
          cartDrawerWrapper,
          document.querySelector(".cart-item__name")
        );
      }
    });

    CartPerformance.measureFromEvent(`updateQuantity:user-action`, event);

    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "cart-items",
      cartData: parsedState,
      variantId: variantId,
    });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            }).then(() =>
              CartPerformance.measureFromEvent("note-update:user-action", event)
            );
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
